import gaAnalytics from "@analytics/google-analytics";
import analytics from "analytics";
import { useEffect } from "react";

import { useCurrentUser } from "@equidefi/portals/hooks/useUsers";
import { userFullName } from "@equidefi/shared";

import { CONFIG } from "@/constants/config";

const EQUIDEFI_GA_MEASUREMENT_IDS: Record<string, string> = {
  production: "G-XGFHPM900T",
  staging: "G-DSN7Z0XCT9",
  demo: "G-RKKZJZL7RN",
  dev: "G-7L826GKWJ2",
};

const APP_NAME = "eq-investor-portal-equidefi-ga";
const INSTANCE_NAME = "equidefiGA";

const measurementId = EQUIDEFI_GA_MEASUREMENT_IDS?.[CONFIG?.ENV];

export const equidefiGAAnalytics = measurementId
  ? analytics({
      app: APP_NAME,
      plugins: [
        {
          ...gaAnalytics({
            measurementIds: [measurementId],
            instanceName: INSTANCE_NAME,
          }),
          name: `google-analytics-${INSTANCE_NAME}`,
        },
      ],
    })
  : null;

export const useEquidefiGAIdentify = () => {
  const { data: user } = useCurrentUser();

  useEffect(() => {
    if (!user?.id || !equidefiGAAnalytics) return;
    equidefiGAAnalytics.identify(user.id, {
      email: user.email,
      phone: user.phone,
      name: userFullName(user, { middle: "none" }),
    });
  }, [user]);
};
